export const CRYPTO_EXCHANGE_CURRENCY_TEST_ID = 'crypto_exchange_currency';
export const CRYPTO_EXCHANGE_LIMITS_LABEL_TEST_ID =
  'crypto_exchange_limits-label';
export const CRYPTO_EXCHANGE_DESTINATION_TEST_ID =
  'crypto_exchange_destination';
export const CRYPTO_EXCHANGE_ACCOUNT_UNAVAILABLE_TEST_ID =
  'crypto_exchange_account-unavailable';
export const CRYPTO_EXCHANGE_DESTINATION_INPUT_TEST_ID =
  'crypto_exchange_destination-input';
export const CRYPTO_EXCHANGE_DESTINATION_DETAILS_LABEL_TEST_ID =
  'crypto_exchange_destination-details-label';
export const CRYPTO_EXCHANGE_DESTINATION_HINT_LABEL_TEST_ID =
  'crypto_exchange_destination-hint-label';
export const CRYPTO_EXCHANGE_RATE_LOADING_TEST_ID =
  'crypto_exchange_rate-loading';

export const exchangeErrorLookup: Record<string, string> = {
  insufficient_funds_for_transaction_fee:
    'Amount is too small to cover the transaction fee.',
  amount_too_small_after_fees:
    'Amount is too small to create an exchange after fees and rounding.',
  amount_above_maximum:
    'This amount is more than we can exchange in one go right now. Split it into multiple smaller exchanges.'
};

export const AMOUNT_ABOVE_MAXIMUM_ERROR_CODE = 'amount_above_maximum';

export const DEFAULT_EXCHANGE_ERROR_MESSAGE =
  'Unable to create exchange request';
